import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/home.page";
import NoAccessPage from "./pages/no-access.page";
import BatchViewPage from "./pages/batches/batch-view.page";

export const AuthenticatedRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/batches/:id" element={<BatchViewPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="*" element={<NoAccessPage />} />
      </Routes>
    </div>
  );
};
